<app-header></app-header>

<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<section id="wrapper" class="error-page">
    <div class="container-fluid error-box">
        <div class="row">
            <div class=" col-xxl-10 offset-xxl-1 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-xs-12  error-body text-center">
                <h3 class="text-center">Ha ocurrido un error</h3>
                <p class="text-muted m-t-30 m-b-30">Te invitamos a volver a intentarlo.</p>
                <a href="index.html" class="btn btn-link btn-rounded waves-effect waves-light m-b-40">AYUDA UADE</a> 
            </div>
            <footer class="footer text-center">© {{fecha}} UADE - Help</footer>
        </div>
    </div>
</section>
<!-- ============================================================== -->
<!-- End Wrapper -->
<!-- ============================================================== -->

<footer class="footer-bottom">
    <!-- Container Start -->
    <div class="container container-xs">
        <div class="row">
            <div class="col-sm-6 col-12">
                <!-- Copyright -->
                <div class="copyright">
                    <p>Copyright © {{fecha}} UADE. Todos los derechos reservados.</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Container End -->
    <!-- To Top -->
    <div class="top-to">
        <a id="top" class="" href=""><i class="fa fa-angle-up"></i></a>
    </div>
</footer>